import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

import { MatSnackBar } from '@angular/material/snack-bar';

import { UserService } from '@core/services/user.service';
import { VideoType } from '@core/enums/video-type';

export const PlaylistGuard: CanActivateFn = async (route, state) => {

	const router = inject(Router);
	const userService = inject(UserService);

	let routeExtras = router.getCurrentNavigation()?.extras ?? null;
	if (routeExtras == null || !routeExtras.state) {

		showNotification();

		// todo redirect to home
		return false;
	}

	if (routeExtras.state['type'] == VideoType.Video && !userService.getToken()) {

		showNotification();

		// todo redirect to home
		return false;
	}

	return true;
}

const showNotification = () => {

	const snackBar = inject(MatSnackBar);

	snackBar.open('De video kan niet geladen worden. Probeer het opnieuw.', undefined, {
		panelClass: ['kwo-snackbar', 'alert', 'text-only'],
		duration: undefined
	});
}